module.exports = __webpack_public_path__ + "img/maker-4.8c6e7279.jpg";